import { FC } from 'react'

import { AppointmentModel } from '@models/appointment'

import { AppointmentAgendaEmpty } from '@modules/appointment/components/AppointmentAgendaEmpty'

import TypeUtil from '@/utils/typeUtil'

import { AppointmentAgendaTimeline } from '../AppointmentAgendaTimeline'

type Props = {
  title: string
  appointments: Array<AppointmentModel>
}

const AppointmentTimelineCard: FC<Props> = ({ title, appointments }) => {
  return (
    <div className="d-flex flex-column rounded border h-100 flex-equal">
      <div className="p-5 border-bottom">
        <div className="fs-5 fw-medium">{title}</div>
      </div>

      <div className="p-5 flex-equal overflow-y-auto">
        {TypeUtil.isEmpty(appointments) ? (
          <AppointmentAgendaEmpty />
        ) : (
          <AppointmentAgendaTimeline appointments={appointments} />
        )}
      </div>
    </div>
  )
}

export default AppointmentTimelineCard
